module.exports = __webpack_public_path__ + "static/media/bass-cello.eecee129.mp3";